import {useEffect} from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import Swal from "sweetalert2";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { theme } from "./theme/darkTheme";
import { GlobalStyles } from "./globalStyles";
import styled from "styled-components";

import Sidebar from "./components/Sidebar";

import OrderHistory from "./components/OrderHistory";
import FinancialStats from "./components/FinancialStats";
import Inventory from "./components/Inventory";
import Deshboard from "./components/Deshboard";
import OrderBoard from "./components/OrderBoard";
import ProductAdmin from "./components/ProductAdmin";
import NewOrder from "./components/NewOrder";

export const AppLayout = styled.div`
  display: flex;
  background-color: ${(props) => props.theme.colors?.background || "#f8fafc"};
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }
`;

export const MainContent = styled.main`
  flex: 1;
  margin-left: 260px;
  min-height: 100vh;
  transition: all 0.3s ease-in-out;
  display: flex;
  flex-direction: column;

  /* Ajuste para Tablets */
  @media (max-width: 1024px) {
    margin-left: 0;
    padding: 20px;
    padding-top: 80px;
  }

  /* Ajuste para Celulares (Mobile) */
  @media (max-width: 768px) {
    margin-left: 0;
    width: 100%;
    padding: 16px;
    padding-top: 70px;
  }
`;

function App() { 
useEffect(() => {
    let timerInterval;
    const tempoDeLeitura = 5; 

    const authTimer = setTimeout(() => {
      Swal.fire({
        title: '<span style="font-size: 1.2rem; letter-spacing: 1px;">SISTEMA OPERACIONAL NINJA BURGER</span>',
        icon: 'info',
        html: `
          <div style="text-align: left; font-family: 'Inter', sans-serif; font-size: 0.9rem; line-height: 1.6; color: #e2e8f0;">
            
            <div style="text-align: center; margin-bottom: 20px;">
               <h3 style="color: #fff; margin-bottom: 5px;">Olá! Seja muito bem-vindo(a).</h3>
               <p style="color: #94a3b8; font-size: 0.85rem;">Agradecemos por acessar nossa plataforma de inteligência.</p>
            </div>

            <p style="border-left: 4px solid #3b82f6; padding-left: 15px; margin-bottom: 20px; color: #94a3b8; font-style: italic;">
              Para garantir a melhor experiência e a segurança dos dados, por favor, observe nossas diretrizes:
            </p>

            <div style="background: #1e293b; padding: 18px; border-radius: 10px; border: 1px solid #334155;">
              <div style="margin-bottom: 15px;">
                <b style="color: #f1f5f9; display: block; margin-bottom: 4px;">01. PRESERVAÇÃO ESTRUTURAL</b>
                <span style="color: #94a3b8;">Os registros históricos são a base da nossa análise. <b>Não altere ou exclua</b> dados preexistentes no sistema.</span>
              </div>

              <div style="margin-bottom: 15px;">
                <b style="color: #3b82f6; display: block; margin-bottom: 4px;">02. LIBERDADE DE CRIAÇÃO</b>
                <span style="color: #94a3b8;">Sinta-se livre para criar pedidos e produtos! Você tem autonomia total para gerenciar e <b>excluir</b> tudo o que for criado por você.</span>
              </div>

              <div>
                <b style="color: #f1f5f9; display: block; margin-bottom: 4px;">03. COMPROMISSO COM A ORDEM</b>
                <span style="color: #94a3b8;">Sua colaboração mantém o ecossistema saudável e os relatórios precisos para todos.</span>
              </div>
            </div>

            <div style="margin-top: 25px; text-align: center;">
               <p style="color: #3b82f6; font-weight: 600; margin-bottom: 10px;">Desejamos uma excelente navegação!</p>
               <p style="font-size: 0.75rem; color: #64748b; text-transform: uppercase; letter-spacing: 2px;">Validando acesso em instantes...</p>
            </div>
          </div>
        `,
        confirmButtonText: `AGUARDE (${tempoDeLeitura}s)`,
        confirmButtonColor: '#2563eb',
        background: '#0f172a',
        color: '#f1f5f9',
        allowOutsideClick: false,
        allowEscapeKey: false,
        padding: '2.5em',
        width: '600px',
        didOpen: () => {
          const confirmBtn = Swal.getConfirmButton();
          confirmBtn.disabled = true;
          
          let secondsLeft = tempoDeLeitura;
          
          timerInterval = setInterval(() => {
            secondsLeft -= 1;
            confirmBtn.innerText = `AGUARDE (${secondsLeft}s)`;
            
            if (secondsLeft <= 0) {
              clearInterval(timerInterval);
              confirmBtn.disabled = false;
              confirmBtn.innerText = 'CONCORDAR E ENTRAR';
            }
          }, 1000);
        },
        willClose: () => {
          clearInterval(timerInterval);
        }
      });
    }, 1200);

    return () => clearTimeout(authTimer);
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Router>
        <AppLayout>
          <Sidebar />
          <MainContent>
            <Routes>
              <Route path="/" element={<Deshboard />} />

              <Route path="/estoque" element={<Inventory />} />
              <Route path="/historico" element={<OrderHistory />} />
              <Route path="/financeiro" element={<FinancialStats />} />
              <Route path="/OrderBoard" element={<OrderBoard />} />
              <Route path="/NewOrder" element={<NewOrder />} />
              <Route path="/ProductAdmin" element={<ProductAdmin />} />
            </Routes>
          </MainContent>
        </AppLayout>
      </Router>
      <ToastContainer position="bottom-right" autoClose={3000} />
      <GlobalStyles />
    </ThemeProvider>
  );
}

export default App;
